import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "@/data/products";

const FinishMarquee = () => (
  <div className="bg-sand py-10 md:py-14" data-testid="finish-marquee">
    <Marquee speed={26} gradient={false} pauseOnHover>
      {MARQUEE_ITEMS.map((f) => (
        <span key={f} className="mx-8 flex items-center gap-16 md:mx-12 md:gap-24">
          <span className="font-display text-2xl font-medium uppercase tracking-[0.08em] text-ink/70 md:text-4xl">
            {f}
          </span>
          <span className="h-1.5 w-1.5 rounded-full bg-ink/25" aria-hidden="true" />
        </span>
      ))}
    </Marquee>
  </div>
);

export default FinishMarquee;
